import React, { useState, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';
import BASE_URL from '../utils/api';
import { mensagemErroDocumento } from '../utils/validarDocumento';

function CriarConta() {
    const navigate = useNavigate();
    const [step, setStep] = useState(1); // 1: login/senha, 2: PF/PJ, 3: dados usuario, 4: política de privacidade
    const [formData, setFormData] = useState({
        // Step 1
        login: '',
        senha: '',
        confirmarSenha: '',
        // Step 2
        tipoPessoa: '', // 'PF' ou 'PJ'
        cpf: '',
        cnpj: '',
        razaoSocial: '',
        // Sede (PJ) - endereço da empresa
        sedeCep: '',
        sedeLogradouro: '',
        sedeNumero: '',
        sedeComplemento: '',
        sedeBairro: '',
        sedeCidade: '',
        sedeUf: '',
        sedePais: 'Brasil',
        // Step 3 - dados e endereço
        nomeUsuario: '',
        email: '',
        telefone: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        uf: '',
        pais: 'Brasil'
    });
    const [loading, setLoading] = useState(false);
    const [loadingCep, setLoadingCep] = useState(false);
    const [loadingSedeCep, setLoadingSedeCep] = useState(false);
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    // Step 4: Aceite da Política de Privacidade

const handleChange = (e) => {
        const { name, value } = e.target;
        // Proibir espaços em login e senhas: removemos quaisquer espaços inseridos
        let cleanValue = value;
        if (name === 'login' || name === 'senha' || name === 'confirmarSenha') {
            if (/\s/.test(value)) {
                cleanValue = value.replace(/\s/g, '');
                setError('Espaços não são permitidos em login ou senha.');
                // limpa o aviso depois de curto período
                setTimeout(() => setError(''), 2200);
            }
        }
        // CPF e CNPJ: aceitar apenas números
        if (name === 'cpf' || name === 'cnpj') {
            cleanValue = value.replace(/\D/g, '').slice(0, name === 'cpf' ? 11 : 14);
        }
        // CEP: aceitar apenas números
        if (name === 'cep' || name === 'sedeCep') {
            cleanValue = value.replace(/\D/g, '').slice(0, 8);
        }
        setFormData(prev => ({ ...prev, [name]: cleanValue }));
        // Ao digitar CEP com 8 dígitos, buscar endereço automático
        if (name === 'cep' && cleanValue.length === 8) {
            buscarCep(cleanValue);
        }
        if (name === 'sedeCep' && cleanValue.length === 8) {
            buscarSedeCep(cleanValue);
        }
    };

    const buscarCep = useCallback(async (cep) => {
        setLoadingCep(true);
        try {
            const resp = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            if (resp.ok) {
                const data = await resp.json();
                if (!data.erro) {
                    setFormData(prev => ({
                        ...prev,
                        logradouro: data.logradouro || prev.logradouro,
                        bairro: data.bairro || prev.bairro,
                        cidade: data.localidade || prev.cidade,
                        uf: data.uf || prev.uf,
                    }));
                }
            }
        } catch (err) {
            // Silently ignore CEP lookup failures
        } finally {
            setLoadingCep(false);
        }
    }, []);

    const buscarSedeCep = useCallback(async (cep) => {
        setLoadingSedeCep(true);
        try {
            const resp = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            if (resp.ok) {
                const data = await resp.json();
                if (!data.erro) {
                    setFormData(prev => ({
                        ...prev,
                        sedeLogradouro: data.logradouro || prev.sedeLogradouro,
                        sedeBairro: data.bairro || prev.sedeBairro,
                        sedeCidade: data.localidade || prev.sedeCidade,
                        sedeUf: data.uf || prev.sedeUf,
                    }));
                }
            }
        } catch (err) {
            // Silently ignore CEP lookup failures
        } finally {
            setLoadingSedeCep(false);
        }
    }, []);

    const passwordRules = (pwd) => {
        const rules = [
            { id: 'length', label: 'Mínimo 6 caracteres', ok: pwd && pwd.length >= 6 },
            { id: 'composition', label: 'Contém letras, números e caractere especial', ok: pwd && /[A-Za-z]/.test(pwd) && /\d/.test(pwd) && /[^A-Za-z0-9]/.test(pwd) },
        ];
        return rules;
    };

    const toggleShow = () => setShowPassword(s => !s);

    const handleStep1Continue = async (e) => {
        e.preventDefault();
        setError('');
        const rules = passwordRules(formData.senha);
        const validPassword = rules.every(r => r.ok);
        if (!formData.login || !formData.senha || !formData.confirmarSenha) {
            setError('Preencha todos os campos.');
            return;
        }
        if (/\s/.test(formData.login) || /\s/.test(formData.senha) || /\s/.test(formData.confirmarSenha)) {
            setError('Espaços não são permitidos em login ou senha.');
            return;
        }
        if (!validPassword) {
            setError('A senha não atende aos requisitos.');
            return;
        }
        if (formData.senha !== formData.confirmarSenha) {
            setError('A senha e a confirmação devem ser iguais.');
            return;
        }
        setStep(2);
    };

    const handleStep2Continue = async (e) => {
        e.preventDefault();
        setError('');
        if (!formData.tipoPessoa) {
            setError('Selecione o tipo de pessoa (PF ou PJ).');
            return;
        }
        if (formData.tipoPessoa === 'PF' && !formData.cpf) {
            setError('CPF é obrigatório para Pessoa Física.');
            return;
        }
        if (formData.tipoPessoa === 'PJ' && !formData.razaoSocial) {
            setError('Razão Social é obrigatória para Pessoa Jurídica.');
            return;
        }
        if (formData.tipoPessoa === 'PJ' && !formData.cnpj) {
            setError('CNPJ é obrigatório para Pessoa Jurídica.');
            return;
        }
        if (formData.tipoPessoa === 'PJ' && !formData.cpf) {
            setError('CPF do responsável é obrigatório para Pessoa Jurídica.');
            return;
        }
        if (formData.tipoPessoa === 'PF' && formData.cpf.length !== 11) {
            setError('CPF deve ter 11 dígitos.');
            return;
        }
        if (formData.tipoPessoa === 'PJ' && formData.cnpj.length !== 14) {
            setError('CNPJ deve ter 14 dígitos.');
            return;
        }
        if (formData.tipoPessoa === 'PJ' && formData.cpf.length !== 11) {
            setError('CPF do responsável deve ter 11 dígitos.');
            return;
        }
        if (formData.tipoPessoa === 'PF') {
            const erroCpf = mensagemErroDocumento(formData.cpf, 'CPF');
            if (erroCpf) { setError(erroCpf); return; }
        }
        if (formData.tipoPessoa === 'PJ') {
            const erroCnpj = mensagemErroDocumento(formData.cnpj, 'CNPJ');
            if (erroCnpj) { setError(erroCnpj); return; }
            const erroCpfResponsavel = mensagemErroDocumento(formData.cpf, 'CPF');
            if (erroCpfResponsavel) { setError(`CPF do responsável: ${erroCpfResponsavel}`); return; }
        }
        if (formData.tipoPessoa === 'PJ') {
            if (!formData.sedeCep || formData.sedeCep.length !== 8) { setError('CEP da sede é obrigatório e deve ter 8 dígitos.'); return; }
            if (!formData.sedeLogradouro) { setError('Logradouro da sede é obrigatório.'); return; }
            if (!formData.sedeNumero) { setError('Número da sede é obrigatório.'); return; }
            if (!formData.sedeBairro) { setError('Bairro da sede é obrigatório.'); return; }
            if (!formData.sedeCidade) { setError('Cidade da sede é obrigatória.'); return; }
            if (!formData.sedeUf) { setError('UF da sede é obrigatória.'); return; }
        }
        setStep(3);
    };

    // Step 3: apenas validação local, sem API
    const handleStep3Continue = async (e) => {
        e.preventDefault();
        setError('');
        const { nomeUsuario, email, telefone, cep, logradouro, numero, bairro, cidade, uf } = formData;
        if (!nomeUsuario || !email || !telefone) {
            setError('Nome, email e telefone são obrigatórios.');
            return;
        }
        // Para PJ o endereço já foi coletado na sede (step 2)
        if (formData.tipoPessoa !== 'PJ') {
            if (!cep || cep.length !== 8) {
                setError('CEP é obrigatório e deve ter 8 dígitos.');
                return;
            }
            if (!logradouro) { setError('Logradouro é obrigatório.'); return; }
            if (!numero) { setError('Número é obrigatório.'); return; }
            if (!bairro) { setError('Bairro é obrigatório.'); return; }
            if (!cidade) { setError('Cidade é obrigatória.'); return; }
            if (!uf) { setError('UF é obrigatória.'); return; }
        }

        setStep(4);
    };

    // Step 4: Enviar TUDO de uma vez — RegistroEmpresa → DadosUsuario na instância criada
    const handleStep4Submit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            // POST RegistroEmpresa/cadastrar-empresa (rota pública, sem tenant header)
            // O backend cria internamente: Tenant, banco, schema, seed, UsuarioSistema, DadosUsuario e UsuarioSistemaTenant
            const cnpjFinal = formData.tipoPessoa === 'PJ' ? formData.cnpj : formData.cpf;

            // Endereço a usar: sede (PJ) ou endereço pessoal (PF)
            const enderecoPayload = formData.tipoPessoa === 'PJ' ? {
                cep: formData.sedeCep,
                logradouro: formData.sedeLogradouro,
                numero: formData.sedeNumero,
                complemento: formData.sedeComplemento || null,
                bairro: formData.sedeBairro,
                cidade: formData.sedeCidade,
                municipio: formData.sedeCidade,
                uf: formData.sedeUf,
                pais: formData.sedePais || 'Brasil'
            } : {
                cep: formData.cep,
                logradouro: formData.logradouro,
                numero: formData.numero,
                complemento: formData.complemento || null,
                bairro: formData.bairro,
                cidade: formData.cidade,
                municipio: formData.cidade,
                uf: formData.uf,
                pais: formData.pais || 'Brasil'
            };

            const empresaPayload = {
                cnpj: cnpjFinal,
                razaoSocial: formData.tipoPessoa === 'PJ' ? formData.razaoSocial : formData.nomeUsuario,
                nomeFantasia: formData.tipoPessoa === 'PJ' ? formData.razaoSocial : formData.nomeUsuario,
                subdominio: cnpjFinal,
                email: formData.email,
                telefone: formData.telefone,
                loginUsuarioAdmin: formData.login,
                senhaUsuarioAdmin: formData.senha,
                // Campos do usuário administrador (usados para DadosUsuario e UsuarioSistemaTenants)
                tipoPessoa: formData.tipoPessoa,
                cpfUsuarioAdmin: formData.cpf || null,
                nomeUsuario: formData.nomeUsuario,
                emailUsuario: formData.email,
                telefoneUsuario: formData.telefone,
                ...enderecoPayload
            };

            const empresaResp = await fetch(`${BASE_URL}/RegistroEmpresa/cadastrar-empresa`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(empresaPayload)
            });

            if (!empresaResp.ok) {
                const txt = await empresaResp.text();
                let msg = txt;
                try {
                    const j = JSON.parse(txt);
                    msg = j.mensagem || j.message || (j.detalhes ? `${j.mensagem || 'Erro'}: ${j.detalhes}` : txt);
                } catch {}
                throw new Error(msg || `Erro ${empresaResp.status} ao cadastrar empresa`);
            }

            alert('Conta criada com sucesso!');
            navigate('/sidebar/Login');
        } catch (err) {
            console.error('Erro ao criar conta:', err);
            setError('Erro ao criar conta: ' + (err.message || String(err)));
        } finally {
            setLoading(false);
        }
    };


    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)' }}>
            <header style={{
                background: 'linear-gradient(90deg, rgb(235, 133, 0) 0%, rgb(250, 190, 40) 100%)',
                height: 70,
                display: 'flex',
                alignItems: 'center',
                padding: '0 24px',
                justifyContent: 'space-between',
                boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                flexShrink: 0
            }}>
                <span style={{ color: '#fff', fontWeight: 800, fontSize: 'clamp(18px, 3vw, 24px)', letterSpacing: '-0.5px' }}>S6 Gestão</span>
                <Link to="/sidebar/Login" style={{ textDecoration: 'none' }}>
                    <button style={{ padding: '12px 36px', fontSize: 16, fontWeight: 700, background: 'linear-gradient(135deg, rgb(235, 133, 0), rgb(250, 178, 65))', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Entrar</button>
                </Link>
            </header>

            <div style={{ padding: '12px 24px' }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <button style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 16px', background: 'transparent', border: '1px solid #ccc', borderRadius: 8, color: '#555', fontSize: 14, cursor: 'pointer' }}>← Início</button>
                </Link>
            </div>

            <div className="login-container" style={{ flex: 1, minHeight: 'unset', background: 'transparent' }}>
            <div className="login-card">
                <div className="login-header">
                    <h2>📝 Criar Conta</h2>
                    <p>{step === 1 ? 'Passo 1/4 — Login e senha' : step === 2 ? 'Passo 2/4 — Tipo de pessoa' : step === 3 ? 'Passo 3/4 — Dados e endereço' : 'Passo 4/4 — Política de Privacidade'}</p>
                </div>

                {/* STEP 1: Login e Senha */}
                {step === 1 && (
                    <form onSubmit={handleStep1Continue} className="login-form">
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label htmlFor="login">Login</label>
                            <input id="login" name="login" value={formData.login} onChange={handleChange} required disabled={loading} />
                        </div>

                        <div className="form-group password-group">
                            <label htmlFor="senha">Senha</label>
                            <div className="input-with-icon">
                                <input id="senha" name="senha" type={showPassword ? 'text' : 'password'} value={formData.senha} onChange={handleChange} required disabled={loading} />
                                <button type="button" onClick={toggleShow} className="password-toggle" aria-label="Mostrar senha">
                                    {showPassword ? (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                                            <path d="M3 3l18 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M17.94 17.94A10.95 10.95 0 0 1 12 20c-5 0-9.27-3-11-8 1.1-2.9 3.2-5.2 5.7-6.6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    ) : (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            <circle cx="12" cy="12" r="3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </button>
                            </div>

                            <div className="form-group password-group">
                                <label htmlFor="confirmarSenha">Confirmar Senha</label>
                                <div className="input-with-icon">
                                    <input id="confirmarSenha" name="confirmarSenha" type={showPassword ? 'text' : 'password'} value={formData.confirmarSenha} onChange={handleChange} required disabled={loading} />
                                    <button type="button" onClick={toggleShow} className="password-toggle" aria-label="Mostrar senha">
                                        {showPassword ? (
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                                                <path d="M3 3l18 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M17.94 17.94A10.95 10.95 0 0 1 12 20c-5 0-9.27-3-11-8 1.1-2.9 3.2-5.2 5.7-6.6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        ) : (
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                                                <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                <circle cx="12" cy="12" r="3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            <ul className="password-rules">
                                {passwordRules(formData.senha).map(rule => (
                                    <li key={rule.id} className={`password-rule ${rule.ok ? 'valid' : 'invalid'}`}>
                                        {rule.ok ? '✓' : '●'} {rule.label}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="login-actions">
                            <button type="submit" className="login-btn" disabled={loading || !passwordRules(formData.senha).every(r => r.ok) || (formData.confirmarSenha && formData.senha !== formData.confirmarSenha)}>{loading ? '⏳ Processando...' : 'Continuar'}</button>
                        </div>
                    </form>
                )}

                {/* STEP 2: Tipo Pessoa (PF/PJ) + CPF ou CNPJ */}
                {step === 2 && (
                    <form onSubmit={handleStep2Continue} className="login-form">
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label htmlFor="tipoPessoa">Tipo de Pessoa</label>
                            <select id="tipoPessoa" name="tipoPessoa" value={formData.tipoPessoa} onChange={handleChange} required disabled={loading}>
                                <option value="">Selecione...</option>
                                <option value="PF">Pessoa Física (PF)</option>
                                <option value="PJ">Pessoa Jurídica (PJ)</option>
                            </select>
                        </div>

                        {formData.tipoPessoa === 'PF' && (
                            <div className="form-group">
                                <label htmlFor="cpf">CPF</label>
                                <input id="cpf" name="cpf" value={formData.cpf} onChange={handleChange} placeholder="00000000000" required disabled={loading} />
                                <small style={{ color: '#888', fontSize: '12px', marginTop: '4px' }}>Este CPF será usado como CPF Usuário e CPF Empregado</small>
                            </div>
                        )}

                        {formData.tipoPessoa === 'PJ' && (
                            <>
                                        <div className="form-group">
                                    <label htmlFor="razaoSocial">Razão Social</label>
                                    <input id="razaoSocial" name="razaoSocial" value={formData.razaoSocial} onChange={handleChange} placeholder="Nome da empresa" required disabled={loading} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cnpj">CNPJ</label>
                                    <input id="cnpj" name="cnpj" value={formData.cnpj} onChange={handleChange} placeholder="00000000000000" required disabled={loading} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="cpf">CPF do Responsável</label>
                                    <input id="cpf" name="cpf" value={formData.cpf} onChange={handleChange} placeholder="00000000000" required disabled={loading} />
                                </div>

                                <hr style={{ margin: '16px 0', borderColor: '#ddd' }} />
                                <p style={{ fontWeight: 600, marginBottom: 4 }}>Endereco da Sede</p>
                                <p style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>O endereco da sede da empresa e necessario para ser apresentado nos contratos gerados e enviados para assinatura.</p>

                                <div className="form-group">
                                    <label htmlFor="sedeCep">CEP da Sede *</label>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <input id="sedeCep" name="sedeCep" value={formData.sedeCep} onChange={handleChange} placeholder="00000000" required disabled={loading} style={{ flex: 1 }} />
                                        {loadingSedeCep && <span style={{ fontSize: 12, color: '#888' }}>Buscando...</span>}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="sedeLogradouro">Logradouro *</label>
                                    <input id="sedeLogradouro" name="sedeLogradouro" value={formData.sedeLogradouro} onChange={handleChange} placeholder="Rua, Av., Alameda..." required disabled={loading} />
                                </div>
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                    <div className="form-group" style={{ flex: '0 0 120px', minWidth: 120 }}>
                                        <label htmlFor="sedeNumero">Numero *</label>
                                        <input id="sedeNumero" name="sedeNumero" value={formData.sedeNumero} onChange={handleChange} placeholder="123" required disabled={loading} />
                                    </div>
                                    <div className="form-group" style={{ flex: '1 1 200px', minWidth: 160 }}>
                                        <label htmlFor="sedeComplemento">Complemento</label>
                                        <input id="sedeComplemento" name="sedeComplemento" value={formData.sedeComplemento} onChange={handleChange} placeholder="Sala, Andar..." disabled={loading} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="sedeBairro">Bairro *</label>
                                    <input id="sedeBairro" name="sedeBairro" value={formData.sedeBairro} onChange={handleChange} required disabled={loading} />
                                </div>
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                    <div className="form-group" style={{ flex: '1 1 220px', minWidth: 180 }}>
                                        <label htmlFor="sedeCidade">Cidade *</label>
                                        <input id="sedeCidade" name="sedeCidade" value={formData.sedeCidade} onChange={handleChange} required disabled={loading} />
                                    </div>
                                    <div className="form-group" style={{ flex: '0 0 120px', minWidth: 120 }}>
                                        <label htmlFor="sedeUf">UF *</label>
                                        <select id="sedeUf" name="sedeUf" value={formData.sedeUf} onChange={handleChange} required disabled={loading}>
                                            <option value="">UF</option>
                                            <option value="AC">AC</option><option value="AL">AL</option><option value="AP">AP</option><option value="AM">AM</option>
                                            <option value="BA">BA</option><option value="CE">CE</option><option value="DF">DF</option><option value="ES">ES</option>
                                            <option value="GO">GO</option><option value="MA">MA</option><option value="MT">MT</option><option value="MS">MS</option>
                                            <option value="MG">MG</option><option value="PA">PA</option><option value="PB">PB</option><option value="PR">PR</option>
                                            <option value="PE">PE</option><option value="PI">PI</option><option value="RJ">RJ</option><option value="RN">RN</option>
                                            <option value="RS">RS</option><option value="RO">RO</option><option value="RR">RR</option><option value="SC">SC</option>
                                            <option value="SP">SP</option><option value="SE">SE</option><option value="TO">TO</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="login-actions">
                            <button type="button" onClick={() => setStep(1)} className="logout-btn" disabled={loading}>Voltar</button>
                            <button type="submit" className="login-btn" disabled={loading}>{loading ? '⏳ Processando...' : 'Continuar'}</button>
                        </div>
                    </form>
                )}

                {/* STEP 3: Dados do Usuário + Endereço */}
                {step === 3 && (
                    <form onSubmit={handleStep3Continue} className="login-form">
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label htmlFor="nomeUsuario">Nome Completo / Razão Social</label>
                            <input id="nomeUsuario" name="nomeUsuario" value={formData.nomeUsuario} onChange={handleChange} required disabled={loading} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required disabled={loading} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="telefone">Telefone</label>
                            <input id="telefone" name="telefone" value={formData.telefone} onChange={handleChange} placeholder="(00) 00000-0000" required disabled={loading} />
                        </div>

                        {formData.tipoPessoa !== 'PJ' && (<>
                        <hr style={{ margin: '16px 0', borderColor: '#ddd' }} />
                        <p style={{ fontWeight: 600, marginBottom: 8 }}>Endereço</p>

                        <div className="form-group">
                            <label htmlFor="cep">CEP *</label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <input
                                    id="cep" name="cep"
                                    value={formData.cep}
                                    onChange={handleChange}
                                    placeholder="00000000"
                                    required
                                    disabled={loading}
                                    style={{ flex: 1 }}
                                />
                                {loadingCep && <span style={{ fontSize: 12, color: '#888' }}>🔍 Buscando...</span>}
                            </div>
                            <small style={{ color: '#888', fontSize: 12 }}>Digite o CEP para preencher o endereço automaticamente</small>
                        </div>

                        <div className="form-group">
                            <label htmlFor="logradouro">Logradouro *</label>
                            <input id="logradouro" name="logradouro" value={formData.logradouro} onChange={handleChange} placeholder="Rua, Av., Alameda..." required disabled={loading} />
                        </div>

                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <div className="form-group" style={{ flex: '0 0 120px', minWidth: 120 }}>
                                <label htmlFor="numero">Número *</label>
                                <input id="numero" name="numero" value={formData.numero} onChange={handleChange} placeholder="123" required disabled={loading} />
                            </div>
                            <div className="form-group" style={{ flex: '1 1 200px', minWidth: 160 }}>
                                <label htmlFor="complemento">Complemento</label>
                                <input id="complemento" name="complemento" value={formData.complemento} onChange={handleChange} placeholder="Apto, Sala..." disabled={loading} />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="bairro">Bairro *</label>
                            <input id="bairro" name="bairro" value={formData.bairro} onChange={handleChange} required disabled={loading} />
                        </div>

                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <div className="form-group" style={{ flex: '1 1 220px', minWidth: 180 }}>
                                <label htmlFor="cidade">Cidade *</label>
                                <input id="cidade" name="cidade" value={formData.cidade} onChange={handleChange} required disabled={loading} />
                            </div>
                            <div className="form-group" style={{ flex: '0 0 120px', minWidth: 120 }}>
                                <label htmlFor="uf">UF *</label>
                                <select id="uf" name="uf" value={formData.uf} onChange={handleChange} required disabled={loading}>
                                    <option value="">UF</option>
                                    <option value="AC">AC</option>
                                    <option value="AL">AL</option>
                                    <option value="AP">AP</option>
                                    <option value="AM">AM</option>
                                    <option value="BA">BA</option>
                                    <option value="CE">CE</option>
                                    <option value="DF">DF</option>
                                    <option value="ES">ES</option>
                                    <option value="GO">GO</option>
                                    <option value="MA">MA</option>
                                    <option value="MT">MT</option>
                                    <option value="MS">MS</option>
                                    <option value="MG">MG</option>
                                    <option value="PA">PA</option>
                                    <option value="PB">PB</option>
                                    <option value="PR">PR</option>
                                    <option value="PE">PE</option>
                                    <option value="PI">PI</option>
                                    <option value="RJ">RJ</option>
                                    <option value="RN">RN</option>
                                    <option value="RS">RS</option>
                                    <option value="RO">RO</option>
                                    <option value="RR">RR</option>
                                    <option value="SC">SC</option>
                                    <option value="SP">SP</option>
                                    <option value="SE">SE</option>
                                    <option value="TO">TO</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="pais">País</label>
                            <input id="pais" name="pais" value={formData.pais} onChange={handleChange} disabled={loading} />
                        </div>
                        </>)}

                        <div className="login-actions">
                            <button type="button" onClick={() => setStep(2)} className="logout-btn" disabled={loading}>Voltar</button>
                            <button type="submit" className="login-btn" disabled={loading || loadingCep}>{loading ? '⏳ Cadastrando...' : 'Continuar'}</button>
                        </div>
                    </form>
                )}

                {/* STEP 4: Confirmação final */}
                {step === 4 && (
                    <form onSubmit={handleStep4Submit} className="login-form">
                        {error && <div className="error-message">{error}</div>}
                        <p>Clique em <strong>Criar Conta</strong> para finalizar o cadastro.</p>
                        <div className="login-actions">
                            <button type="button" onClick={() => setStep(3)} className="logout-btn" disabled={loading}>Voltar</button>
                            <button type="submit" className="login-btn" disabled={loading}>{loading ? '⏳ Criando...' : 'Criar Conta'}</button>
                        </div>
                    </form>
                )}
            </div>
            </div>
        </div>
    );
}

export default CriarConta;

